import * as React from 'react';
import { gsap } from 'gsap';

import { Ball, BOUNCE_MAGNITUDE } from './CssVsJs.helpers';

interface Props {
  isPlaying: boolean;
}

function BallGsap({ isPlaying }: Props) {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!isPlaying) {
      return;
    }

    const animation = gsap.to(ref.current!, {
      x: BOUNCE_MAGNITUDE,
      duration: 1,
      ease: 'none',
      repeat: -1,
      yoyo: true,
    });

    return () => {
      animation.kill();
    };
  }, [isPlaying]);

  return <Ball ref={ref} />;
}

export default BallGsap;
